// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"style_mainDiv__1yq4V","understoodBtn":"style_understoodBtn__2_1G6"};